import { Button } from '@mui/material';
export const RedirectNode: React.FC<{
  fieldNumber: number;
  onNavigate?: (tabId: string, props?: any) => void;
}> = ({ fieldNumber, onNavigate }) => {
  return (
    <div className="mt-4 flex justify-between">
      {/* <Button
        variant="contained"
        color="primary"
        onClick={() => handleNavigation('time-series-plot')}
        sx={{
          marginRight: 2,
          backgroundColor: '#006970',
          '&:hover': {
            backgroundColor: '#006970',
            boxShadow: 'none',
          },
          width: '400px',
          height: '50px',
          fontSize: '10px',
        }}>
        Go to Time Series Plot
      </Button> */}

      <Button
        variant="contained"
        color="primary"
        onClick={() =>
          onNavigate?.('timeseries', {
            fieldId: fieldNumber,
          })
        }
        sx={{
          backgroundColor: '#006970',
          '&:hover': {
            backgroundColor: '#006970',
            boxShadow: 'none',
          },
          width: '100px',
          height: '40px',
          fontSize: '10px',
        }}>
        View field
      </Button>
    </div>
  );
};
